// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailableBalance_root__10_8j"};